<template>
  <div class="mdBxFiller" :class="[flexClass, hoverPath === parentPath + 'filler' ? 'on-hover' : '']" :style="{flexGrow: filler.flex}">
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageFiller } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: [],
})
export default class Filler extends Vue {
  @Prop()
  filler!: IFlexMessageFiller

  @Prop()
  parentPath!: string

  @Prop()
  hoverPath!: string

  get flexClass() {
    if (this.filler.flex === 0) {
      return 'fl0'
    } else if (this.filler.flex === 1) {
      return 'fl1'
    } else if (this.filler.flex === 2) {
      return 'fl2'
    } else if (this.filler.flex === 3) {
      return 'fl3'
    }
    return ''
  }
}
</script>

<style scoped lang="scss">

</style>
